import { EQUIPMENT } from '../../../equipment/constants'
import { WEIGHT_EQUIPMENT_TYPE } from '../../../../constant'
import { getEquipmentExerciseUtil } from '../../../exercise'

const EQUIPMENT_TYPE_TO_WEIGHT_EQUIPMENT_TYPE = {
  [EQUIPMENT.BARBELL]: WEIGHT_EQUIPMENT_TYPE.BARBELL,
  [EQUIPMENT.DUMBBELL]: WEIGHT_EQUIPMENT_TYPE.DUMBBELL,
  [EQUIPMENT.EZ_BAR]: WEIGHT_EQUIPMENT_TYPE.EZ_BAR,
  [EQUIPMENT.DUMBBELL]: WEIGHT_EQUIPMENT_TYPE.DUMBBELL,
  [EQUIPMENT.PLATE]: WEIGHT_EQUIPMENT_TYPE.PLATE,
  [EQUIPMENT.KETTLEBELL]: WEIGHT_EQUIPMENT_TYPE.KETTLEBELL
}

function getEquipmentTypeWeightUtil (exercise) {
  const equipment = getEquipmentExerciseUtil(exercise)
  let weightEquipmentTypeFound
  equipment.find(eq => {
    weightEquipmentTypeFound = EQUIPMENT_TYPE_TO_WEIGHT_EQUIPMENT_TYPE[eq]
    return weightEquipmentTypeFound
  })
  return weightEquipmentTypeFound
}

export { getEquipmentTypeWeightUtil }
